module.exports = __webpack_public_path__ + "img/poetsinstructie aangepast.c1295e91.png";